import { render, staticRenderFns } from "./evaluacionPoligrafia.vue?vue&type=template&id=af98e440&"
import script from "./evaluacionPoligrafia.vue?vue&type=script&lang=js&"
export * from "./evaluacionPoligrafia.vue?vue&type=script&lang=js&"
import style0 from "./evaluacionPoligrafia.vue?vue&type=style&index=0&id=af98e440&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports